<template>
  <div id="project" class="project__edit__wrapper">
    <HeaderControlsProject :myWeek='false' @filterUpdated='false' @collapseToggleUpdated='false'  :namespace="namespace"/>
    <div class="container-fluid project--details">
      <ProjectDeliverableList  :namespace="namespace"/>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import HeaderControlsProject from "../components/common/HeaderControlsProject";
import ProjectDeliverableList from "../components/deliverables/ProjectDeliverableList";

export default {
  data() {
    return {
    	namespace:""
    }
  },
  components: {
    ...mapGetters([
      'projectDeliverables'
    ]),
    HeaderControlsProject,
    ProjectDeliverableList
  },
  computed: {
    ...mapGetters([
      'projectDetail'
    ])
  },
  watch: {
    projectDetail: {
      handler(val) {
        if (val && val.title) {
          const projectId = val.project_number || val.id;
          document.title = `${val.title} (${projectId})`; 
        }
      },
      immediate: true
    }
  },
  created() {
    const id = this.$route.params.projectId;
    if (id) {
      this.$store.dispatch('fetchProjectDeliverableById', id);
    }
  }
};
</script>
